import { lazyLoad } from 'utils/loadable';

export const ResumeDetailPage = lazyLoad(
  () => import('./index'),
  module => module.ResumeDetailPage,
);
